<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
 <!-- <mobile-menu></mobile-menu> -->
      <template slot-scope="props" slot="links">
        <sidebar-item :link="{name: 'Home', icon: 'fas fa-chart-pie', path: '/admin/home'}"/>
        <sidebar-item :link="{name: 'Payouts', icon: 'fas fa-money-check-edit-alt', path: '/admin/payouts'}"/>
        <sidebar-item :link="{name: 'Invoices', icon: 'fas fa-file-alt', path: '/admin/invoices'}"/>
   <!-- <sidebar-item :link="{name: 'Pages', icon: 'nc-icon nc-puzzle-10'}">
          <sidebar-item :link="{name: 'User Page', path: '/pages/user'}"></sidebar-item>
          <sidebar-item :link="{name: 'Login Page', path: '/login'}"></sidebar-item>
          <sidebar-item :link="{name: 'Register', path: '/register'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lock Screen Page', path: '/lock'}"></sidebar-item>
        </sidebar-item> -->
        <sidebar-item :link="{name: 'Setup', icon: 'fas fa-cog', path: '/admin/setup'}"/>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content v-if="$store.getters.isSetupComplete || $route.path.includes('/setup')" @click.native="toggleSidebar"/>

      <div v-else class="m-4">
        <Welcome-Card class="col-11"/>
      </div>
      

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import UserMenu from './Extra/UserMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      UserMenu
    },
    // beforeCreate () {
    //   this.$store.dispatch('fetchData')
    // },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
